// PowerSync — calendar_events (deadlines, scheduled reviews, exam dates).
import { usePowerSyncQuery } from "@/lib/powersync/use-query";

export interface LocalCalendarEvent {
	id: string;
	user_id: string;
	type: string;
	title: string;
	description: string | null;
	start_at: string;
	end_at: string | null;
	event_type: string | null;
	all_day: number | null;
	location: string | null;
	recurrence_rule: string | null;
	reminder_minutes: number | null;
	study_plan_id: string | null;
	subsection_id: string | null;
	reminded: number | null;
	metadata: string | null;
	created_at: string;
	updated_at: string;
	deleted_at: string | null;
}

export function useCalendarRangeQuery(userId: string | undefined, fromIso: string, toIso: string) {
	return usePowerSyncQuery<LocalCalendarEvent>(
		`SELECT * FROM calendar_events
		   WHERE user_id = ?
		     AND deleted_at IS NULL
		     AND start_at >= ?
		     AND start_at < ?
		ORDER BY start_at ASC`,
		[userId ?? "", fromIso, toIso],
	);
}

export function useUpcomingEventsQuery(userId: string | undefined) {
	return usePowerSyncQuery<LocalCalendarEvent>(
		`SELECT * FROM calendar_events
		   WHERE user_id = ? AND start_at >= ?
		ORDER BY start_at ASC`,
		[userId ?? "", new Date().toISOString()],
	);
}
